import React from "react";
import "./InputField.scss";

function InputField({
                        label,
                        type = "text",
                        id,
                        className = "input",
                        value,
                        placeholder,
                        onChange,
                    }) {
    return (
        <div className="input-field">
            <label htmlFor={id}>{label}</label>
            <input
                type={type}
                id={id}
                className={className}
                value={value}
                placeholder={placeholder}
                onChange={onChange}
            />
        </div>
    );
}

export {InputField};
